import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { border, color, mediaQuery, font } = baseVariables;

export const StyledEventConfirmationDetails = styled.div`
  position: relative;

  .confirmation-body {
    flex-direction: column;
    align-items: center;
    .booking-details {
      border-top: ${toRem(1.5)} dashed ${color.neutral40};
    }
    .text-block {
      padding-top: ${toRem(16)} !important;
      .item-value {
        padding-top: 0;
        font-weight: ${font.fontWeightMedium};
        overflow-wrap: anywhere;
      }
    }
  }

  @media ${mediaQuery.md} {
    .confirmation-body {
      flex-direction: row;
      .property-details {
        flex: 1 1 35%;
      }
      .booking-details {
        flex: 1 1 65%;
        border-top: none;
        border-left: ${toRem(1.5)} dashed ${color.neutral40};
      }
    }
  }
`;

export const StyledConfirmationSection = styled.div`
  padding: ${toRem(40)} ${toRem(16)};
  background-color: ${color.base20};
  border: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
  border-radius: ${toRem(12)};
  box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);

  @media ${mediaQuery.md} {
    padding: ${toRem(40)} ${toRem(32)};
  }
`;
